import React, { useState } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../Assets/logo.png";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeItem, setActiveItem] = useState("home");
  const navigate = useNavigate();

  const handleItemClick = (item) => {
    setActiveItem(item);
    setIsMenuOpen(false);
  };

  const navigateHandler = () => {
    navigate("/");
  };

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-24">
          {/* Logo and mobile menu button */}
          <div className="flex items-center">
            <div className="flex-shrink-0 flex items-center cursor-pointer" onClick={navigateHandler}>
              <img className="h-10 w-auto" src={logo} alt="Logo" />
            </div>
          </div>

          {/* Desktop menu items */}
          <div className="hidden md:ml-6 md:flex md:items-center md:space-x-8">
            <Link
              to="/"
              className={`${activeItem === "home" ? "border-[#71b340] text-gray-900" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"} inline-flex items-center px-1 pt-1 border-b-2 font-medium`}
              onClick={() => handleItemClick("home")}
            >
              Home
            </Link>
            <Link
              to="/feature"
              className={`${activeItem === "features" ? "border-[#71b340]  text-gray-900" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"} inline-flex items-center px-1 pt-1 border-b-2 font-medium`}
              onClick={() => handleItemClick("features")}
            >
              Features
            </Link>
            <Link
              to="/price"
              className={`${activeItem === "price" ? "border-[#71b340]  text-gray-900" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"} inline-flex items-center px-1 pt-1 border-b-2  font-medium`}
              onClick={() => handleItemClick("price")}
            >
              Price
            </Link>
            <Link
              to="/solution"
              className={`${activeItem === "solution" ? "border-[#71b340]  text-gray-900" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"} inline-flex items-center px-1 pt-1 border-b-2  font-medium`}
              onClick={() => handleItemClick("solution")}
            >
              Solution
            </Link>
            <Link
              to="/about"
              className={`${activeItem === "about" ? "border-[#71b340]  text-gray-900" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"} inline-flex items-center px-1 pt-1 border-b-2  font-medium`}
              onClick={() => handleItemClick("about")}
            >
              About Us
            </Link>
          </div>

          {/* Desktop buttons */}
          <div className="hidden md:ml-6 md:flex md:items-center md:space-x-4">
            <a
              href="https://panel.divinesoftwares.com.au"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-gray-700 px-3 py-2  font-medium"
            >
              Admin Panel
            </a>
            <Link
              to="/login"
              className="text-blue-600 hover:text-blue-800 px-3 py-2  font-medium"
            >
              Login
            </Link>
            <Link
              to="/register"
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md  font-medium"
            >
              Register
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="-mr-2 flex items-center md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
            >
              <span className="sr-only">Open main menu</span>
              {isMenuOpen ? <FiX className="block h-6 w-6" /> : <FiMenu className="block h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`${isMenuOpen ? 'block' : 'hidden'} md:hidden`}>
        <div className="pt-2 pb-3 space-y-1">
          <Link
            to="/"
            className={`${activeItem === "home" ? "bg-blue-50 border-[#71b340]  text-blue-700" : "border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700"} block pl-3 pr-4 py-2 border-l-4 text-base font-medium`}
            onClick={() => handleItemClick("home")}
          >
            Home
          </Link>
          <Link
            to="/feature"
            className={`${activeItem === "features" ? "bg-blue-50 border-[#71b340]  text-blue-700" : "border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700"} block pl-3 pr-4 py-2 border-l-4 text-base font-medium`}
            onClick={() => handleItemClick("features")}
          >
            Features
          </Link>
          <Link
            to="/price"
            className={`${activeItem === "price" ? "bg-blue-50 border-[#71b340]  text-blue-700" : "border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700"} block pl-3 pr-4 py-2 border-l-4 text-base font-medium`}
            onClick={() => handleItemClick("price")}
          >
            Price
          </Link>
          <Link
            to="/solution"
            className={`${activeItem === "solution" ? "bg-blue-50 border-[#71b340]  text-blue-700" : "border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700"} block pl-3 pr-4 py-2 border-l-4 text-base font-medium`}
            onClick={() => handleItemClick("solution")}
          >
            Solution
          </Link>
          <Link
            to="/about"
            className={`${activeItem === "about" ? "bg-blue-50 border-[#71b340]  text-blue-700" : "border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700"} block pl-3 pr-4 py-2 border-l-4 text-base font-medium`}
            onClick={() => handleItemClick("about")}
          >
            About Us
          </Link>
          <div className="pt-4 pb-3 border-t border-gray-200">
            <div className="mt-3 space-y-1">
              <a
                href="https://panel.divinesoftwares.com.au"
                target="_blank"
                rel="noopener noreferrer"
                className="block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100"
              >
                Admin Panel
              </a>
              <Link
                to="/login"
                className="block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100"
              >
                Login
              </Link>
              <Link
                to="/register"
                className="block px-4 py-2 text-base font-medium text-blue-600 hover:text-blue-800 hover:bg-blue-50"
              >
                Register
              </Link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;